/**
 * Tela desconhecido.
 *
 * Acontece sobretudo quando um plugin e desligado e um atalho antigo continua
 * salvo. A mensagem diz o que aconteceu e oferece a saida, em vez de deixar
 * alguem perdido numa tela vazia.
 */
import { useNavigate } from 'react-router-dom';
import { BigButton, EmptyState, Screen, Stack } from '@flos/ui';
import { SHELL_PATHS } from '../navigation';

export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <Screen title="Não encontrei esta tela">
      <Stack gap="lg">
        <EmptyState
          icon="🧭"
          title="Esta tela já não existe"
          description="Pode ter sido desligado nas Configurações. Nada se perdeu."
          action={
            <BigButton icon="🏠" onClick={() => navigate(SHELL_PATHS.HOME)}>
              Voltar ao início
            </BigButton>
          }
        />
      </Stack>
    </Screen>
  );
}

export default NotFoundScreen;
